import { Outlet } from "react-router-dom";

const Coupon = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default Coupon;